import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[maskInputCalendar]'
})
export class MaskInputCalendarDirective {

  constructor() { }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const date = event.target.value;
    //console.log('event: ', event)

    if (!event.data) {
      return
    }

    if (date.length > 10) {
      event.target.value = event.target.value.slice(0, 10)
    }
    //console.log('form: ', this.form.value.userInfo?.birthdate)

    if (date.length === 2 || date.length === 5) {
      event.target.value = date + '/';
    }
  }

}
